export default __webpack_public_path__ + "8e84bfe84848577251464091b0f068ee.png";